<template>
  <Layout>
    <VContainer fluid grid-list-xl class="contact">
      <VLayout justify-center>
        <VFlex xs12 sm10 md7 lg6 xl4 text-center px-3 py-5>
          <h1 class="support__display-2 text-uppercase text-center">How can we help?</h1>
          <p class="support__headline text-center">
            If you can include details, such as transaction numbers or
            screenshots, we will be able to respond more quickly.
          </p>
        </VFlex>
      </VLayout>
      <VLayout justify-center>
        <VFlex xs12 sm7 md6 lg4 xl3>
          <ContactForm />
        </VFlex>
      </VLayout>
    </VContainer>
  </Layout>
</template>
<script>
import Layout from '~/components/layout/Layout'
import ContactForm from '~/components/ContactForm'

export default {
  components: { Layout, ContactForm }
}
</script>

<style lang="scss">
@import '~/assets/scss/support.scss';

.contact {
  @include text-styles;
}
</style>